export default __webpack_public_path__ + "static/media/ico-aws-EC2Subnet-circle.8a6bcca3.svg";